import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCash = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M16.7498 5.83333V15H2.99982V5.83333H16.7498ZM6.05537 13.4722C6.05537 12.6367 5.3631 11.9444 4.52759 11.9444V13.4722H6.05537ZM4.52759 8.88889C5.3631 8.88889 6.05537 8.22049 6.05537 7.36111H4.52759V8.88889ZM13.6943 13.4722H15.222V11.9444C14.3627 11.9444 13.6943 12.6367 13.6943 13.4722ZM15.222 8.88889V7.36111H13.6943C13.6943 8.22049 14.3627 8.88889 15.222 8.88889ZM9.87482 8.125C9.03931 8.125 8.2993 8.57856 7.86961 9.27083C7.46379 9.98698 7.46379 10.8702 7.86961 11.5625C8.2993 12.2786 9.03931 12.7083 9.87482 12.7083C10.6864 12.7083 11.4265 12.2786 11.8562 11.5625C12.262 10.8702 12.262 9.98698 11.8562 9.27083C11.4265 8.57856 10.6864 8.125 9.87482 8.125Z"
	})
});
const ForwardRef = forwardRef(SvgCash);
export default ForwardRef;
